// Import SASS
import '../sass/style.scss'

// Node_modules
import objectFitImages from 'object-fit-images'

import headerScroll from './modules/header'

// Import scripts
import './modules/skip-link-focus-fix'
import initYoutubeVideos from './modules/init-after-youtube-api' // when videos are loaded on the page

import '../partials/navigation/menus/menus'
// import '../partials/search/search'
import initSliders from '../partials/sliders/sliders'
import { initBlockSlider } from '../partials/blocks/block/block-slider'


import Splide from '@splidejs/splide';



document.addEventListener('DOMContentLoaded', function () {

  if (document.getElementById('slider1')) {
  
const primary = new Splide( '#slider1', {
  // Sets a fixed height (e.g., 400px)
  height: '480px'
});

primary.mount();

var slides2 = document.querySelectorAll('#slider2 .splide__slide');

  slides2.forEach((slide, index) => {
    slide.addEventListener('click', () => {
      // Navigate Slider2 to the slide that corresponds to the clicked slide in Slider1
      resetAndStartProgressBar();
      primary.go(index);

    });
  });

 let progressBarUpdateInterval;

  function resetAndStartProgressBar() {
    // Clear existing interval to reset the progress bar update
    clearInterval(progressBarUpdateInterval);


    // Reset all progress bars to 0% width
    document.querySelectorAll('#slider2 .progress-bar').forEach(function(bar) {
      bar.style.width = '0%';
    });

    // Calculate the progress increment for each frame (assuming 60fps)
    const increment = 100 / (6000 / 16.67); // Total width divided by number of frames in the interval

    progressBarUpdateInterval = setInterval(function() {
      document.querySelectorAll('#slider2 .progress-bar').forEach(function(bar, index) {
        if (index === primary.index) {
          let currentWidth = parseFloat(bar.style.width) || 0;
          let newWidth = currentWidth + increment;
          if (newWidth > 100) {
            newWidth = 100; // Cap the width at 100%
            clearInterval(progressBarUpdateInterval); // Clear the interval once reaching 100%
          }
          bar.style.width = `${newWidth}%`;
        }
      });
    }, 16.67); // Update approximately every 16.67 milliseconds (~60fps)
  }


  // Initialize the progress bar on load
  resetAndStartProgressBar();

  primary.on('move', function (newIndex) {

    resetAndStartProgressBar();

    // This ensures that the class addition and progress bar reset happen even when Slider1 is navigated through other means (arrows, pagination, etc.)
    document.querySelectorAll('#slider2 .splide__slide').forEach((slide, i) => {
      slide.classList.remove('is-active'); // Ensure the class is updated correctly on 'moved'
      if (i === newIndex) {
        slide.classList.add('is-active');
      }
    });
  });


}

});


window.onYouTubeIframeAPIReady = function() {
	initYoutubeVideos();
}

import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles

// Object-fit fix
objectFitImages()

headerScroll('.header');

// Init slider
let sliders = initSliders();
console.log(sliders);

// Expertise items click event
const expertises = document.querySelectorAll('.card__expertise');
for (let i = 0; i < expertises.length; i++) {
    expertises[i].addEventListener('click', (event) => {
        if (!event.target.classList.contains('wp-block-button__link')) {
            expertises[i].classList.toggle('active');
        }
    });
}

if (document.getElementById('purpose__slider-rows')) {

window.addEventListener( 'load', function() {

  var box1 = document.getElementById('purpose__slider-row1'),
      docHeight = document.documentElement.offsetHeight,
      windowWidth = window.innerWidth/100;

    var box2 = document.getElementById('purpose__slider-row2'),
      docHeight = document.documentElement.offsetHeight,
      windowWidth = window.innerWidth/100;

    var box3 = document.getElementById('purpose__slider-row3'),
      docHeight = document.documentElement.offsetHeight,
      windowWidth = window.innerWidth/100;

    var box4 = document.getElementById('purpose__slider-row4'),
      docHeight = document.documentElement.offsetHeight,
      windowWidth = window.innerWidth/100;
  
  window.addEventListener( 'scroll', function() {
        // normalize scroll position as percentage
    var scrolled = windowWidth*(window.scrollY / ( docHeight - window.innerHeight ))*3,
        transformValue1= 'translateX('+scrolled+'px)',
        transformValue2 = 'translateX(-'+scrolled+'px)',
        transformValue3= 'translateX('+scrolled+'px)';

    box1.style.WebkitTransform = transformValue1;
    box1.style.MozTransform = transformValue1;
    box1.style.OTransform = transformValue1;
    box1.style.transform = transformValue1;

    box2.style.WebkitTransform = transformValue2;
    box2.style.MozTransform = transformValue2;
    box2.style.OTransform = transformValue2;
    box2.style.transform = transformValue2;

    box3.style.WebkitTransform = transformValue3;
    box3.style.MozTransform = transformValue3;
    box3.style.OTransform = transformValue3;
    box3.style.transform = transformValue3;

    box4.style.WebkitTransform = transformValue2;
    box4.style.MozTransform = transformValue2;
    box4.style.OTransform = transformValue2;
    box4.style.transform = transformValue2;
    
  }, false);
  
}, false);

}

document.addEventListener('DOMContentLoaded', function () {
  const elements = document.querySelectorAll('.wp-block-media-text__media');
  elements.forEach(function (element) {
    element.setAttribute('data-aos', 'fade-up');
  });
  // ..
AOS.init();

});


if (document.querySelector(".locations__check")) { 

  let box = document.querySelector('.locations__check');

  box.addEventListener("click", function(event){

      var xHor = (event.offsetX / box.offsetWidth) * 100;
      var yVer = (event.offsetY / box.offsetHeight) * 100;
      alert( xHor + '---' + yVer);
  });

}

